// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<iframe src=\"javascript/pdfjs-vecna/viewer.html?file="
    + alias4(((helper = (helper = lookupProperty(helpers,"pdfUrl") || (depth0 != null ? lookupProperty(depth0,"pdfUrl") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pdfUrl","hash":{},"data":data,"loc":{"start":{"line":1,"column":53},"end":{"line":1,"column":63}}}) : helper)))
    + "&isOnTablet="
    + alias4(((helper = (helper = lookupProperty(helpers,"isOnTablet") || (depth0 != null ? lookupProperty(depth0,"isOnTablet") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"isOnTablet","hash":{},"data":data,"loc":{"start":{"line":1,"column":75},"end":{"line":1,"column":89}}}) : helper)))
    + "\" data-test-pdf></iframe>\n";
},"useData":true});
